export default __webpack_public_path__ + "static/media/@just.steh.4ccf220b.jpg";